import "prismjs";
import "prismjs/components/prism-n1ql";
